import { useEffect, useState } from "react";
import { Plus, Trash2, GripVertical } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function SuggestionsAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ label_fr: "", label_en: "", query: "", order: 0, active: true });

  const load = () => api.get("/admin/suggestions").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.label_fr || !form.label_en) return toast.error("Libellés FR et EN requis");
    await api.post("/admin/suggestions", { ...form, order: Number(form.order) || items.length });
    setForm({ label_fr: "", label_en: "", query: "", order: 0, active: true });
    toast.success("Suggestion ajoutée");
    load();
  };

  const toggle = async (s) => { await api.put(`/admin/suggestions/${s.id}`, { active: !s.active }); load(); };
  const del = async (id) => { await api.delete(`/admin/suggestions/${id}`); toast.success("Supprimée"); load(); };

  const inputCls = "w-full border border-tertiary bg-white px-3 py-2 text-sm outline-none focus:border-champagne focus:ring-1 focus:ring-champagne";

  return (
    <div className="max-w-4xl">
      <h1 className="mb-1 font-serif text-3xl text-anthracite">Suggestions de recherche</h1>
      <p className="mb-8 text-sm text-anthracite/50">Exemples dynamiques affichés sous le moteur de recherche.</p>

      <form onSubmit={add} data-testid="suggestion-form" className="mb-8 grid gap-3 border border-tertiary bg-white p-5 sm:grid-cols-4">
        <input placeholder="Libellé FR" value={form.label_fr} onChange={(e) => setForm((f) => ({ ...f, label_fr: e.target.value }))} data-testid="suggestion-fr" className={inputCls} />
        <input placeholder="Libellé EN" value={form.label_en} onChange={(e) => setForm((f) => ({ ...f, label_en: e.target.value }))} data-testid="suggestion-en" className={inputCls} />
        <input placeholder="Requête (recherche)" value={form.query} onChange={(e) => setForm((f) => ({ ...f, query: e.target.value }))} className={inputCls} />
        <button type="submit" data-testid="suggestion-add" className="inline-flex items-center justify-center gap-2 bg-anthracite px-4 py-2 text-sm font-medium text-ivory hover:bg-black"><Plus className="h-4 w-4" /> Ajouter</button>
      </form>

      <div className="border border-tertiary bg-white">
        {items.length === 0 ? (
          <p className="py-12 text-center text-sm text-anthracite/40">Aucune suggestion.</p>
        ) : items.map((s) => (
          <div key={s.id} data-testid={`suggestion-row-${s.id}`} className="flex items-center gap-4 border-b border-tertiary px-5 py-3 last:border-0">
            <GripVertical className="h-4 w-4 text-anthracite/20" />
            <div className="flex-1">
              <p className="text-sm text-anthracite">{s.label_fr}</p>
              <p className="text-xs text-anthracite/50">{s.label_en} · {s.query}</p>
            </div>
            <button onClick={() => toggle(s)} className={`rounded-full border px-2.5 py-0.5 text-xs ${s.active ? "border-green-200 bg-green-50 text-green-700" : "border-tertiary bg-sand text-anthracite/50"}`}>
              {s.active ? "Actif" : "Inactif"}
            </button>
            <button onClick={() => del(s.id)} data-testid={`suggestion-del-${s.id}`} className="rounded p-1.5 text-anthracite/50 hover:bg-red-50 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
